/* eslint-disable */ /* disabled for Hot Loader */

import thunk from 'redux-thunk';
import Promise from 'bluebird';
import { applyMiddleware, createStore, compose } from 'redux';

//allows async await

// Want to make sure we load in our polyfills before starting the
// rest of our app in case we are referencing polyfilled methods
import '../shared/Polyfills';

import Root from './containers/Root';
import reducer from '../shared/Reducer';
import setupSession from './SessionSetup';
import { setReduxStore as setVerbFetchReduxStore } from '../shared/VerbFetch';
import { setReduxStore as setLogReduxStore } from '../shared/utils/log';
import { AuthenticatedUserContextConsumer } from '../../common/AuthenticatedUser';

// Turning off warnings because #yolo
Promise.config({
    warnings: false
});

// We reference a redux dev tool global to set up redux dev tools
// if the user has the browser extension resolved
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const middleware = [thunk];
const store = createStore(reducer, {}, composeEnhancers(applyMiddleware(...middleware)));

// This allows us to use data in the state for our default fetch
setVerbFetchReduxStore(store);
setLogReduxStore(store);
setupSession(store);

const MainContentComponent = () => {
    return (<AuthenticatedUserContextConsumer>
        {(authContext) => authContext?.token ? <Root store={store} authContext={authContext} /> : null}
    </AuthenticatedUserContextConsumer>)};

export default MainContentComponent;
